import React, { FC, useCallback, useEffect, useMemo, useRef } from 'react';

import LoadingAnimation from 'components/loading-animation';
import LoadingContainer from 'components/loading-animation/loading-container';
import { useCreateLoginForVendorMutation } from 'generated/rbi-graphql';
import useAuthRedirects from 'hooks/auth/use-auth-redirects';
import useGoBack from 'hooks/use-go-back';
import { OnAppStateChange, useUpdateOnAppStateChange } from 'hooks/use-update-on-app-state-change';
import { parseJwt } from 'utils/jwt';

interface IVendorRedirectProps {
  vendor: string;
  vendorPath?: string;
}

const VendorRedirect: FC<IVendorRedirectProps> = ({ vendor, vendorPath }) => {
  const [createLoginForVendor, { data }] = useCreateLoginForVendorMutation();
  const hasBeenRedirectedToGameUrl = useRef(false);

  useAuthRedirects();

  const goBack = useGoBack();
  const handleUpdateOnAppStateChange: OnAppStateChange = useCallback(
    ({ isActive }) => {
      if (isActive && hasBeenRedirectedToGameUrl.current) {
        goBack();
        hasBeenRedirectedToGameUrl.current = false;
      }
    },
    [goBack]
  );
  useUpdateOnAppStateChange(handleUpdateOnAppStateChange);

  const jwt = data?.createLoginForVendor;

  const gameUrl = useMemo(() => {
    if (!jwt) {
      return null;
    }
    const parsed = parseJwt(jwt);
    return parsed.aud && `https://${parsed.aud}/${vendorPath ?? 'auth'}?jwt=${jwt}`;
  }, [jwt, vendorPath]);

  useEffect(() => {
    createLoginForVendor({
      variables: {
        vendor,
      },
    });
  }, [createLoginForVendor, vendor]);

  useEffect(() => {
    if (gameUrl) {
      hasBeenRedirectedToGameUrl.current = true;
      window.location.href = gameUrl;
    }
  }, [gameUrl]);

  return (
    <LoadingContainer>
      <LoadingAnimation fillColor={Styles.color.primary} />
    </LoadingContainer>
  );
};

export default VendorRedirect;
